import { Box } from "@chakra-ui/react";
import React from "react";

const Wrapper = ({ children }) => (
  <Box width="100%" maxWidth="24rem" m="0 auto" pl="6" pr="6">
    {children}
  </Box>
);

export default Wrapper;